import { AsyncThunk } from '@reduxjs/toolkit';

/**
 * This function matches passed thunk with action type.
 * @param thunk createAsyncThunk result
 * @returns boolean
 */
export const isAction =
  (thunk: AsyncThunk<any, any, any>) =>
  (action): boolean => {
    const reg = new RegExp(thunk.typePrefix);
    return reg.test(action.type);
  };
